
import greenSvg from "../../images/minified/green.svg"
import blueSvg from "../../images/minified/blue.svg"
import orangeSvg from "../../images/minified/orange.svg"
import { getWhiteLabelDictionary } from "../whitelabel/WhiteLabel.Helper"
import { activelyInterestedObj, highlyEngagedObj } from "../../config/TableColumns.config"

export const getImage = (itemId) => {
    if (itemId === "he") return greenSvg
    if (itemId === "ai") return blueSvg
    return orangeSvg
}
export const getClassType = (itemId) => {
    if (itemId === "he") return " green"
    if (itemId === "ai") return " blue"
    return " orange"
}
export const getTrackKeyInsights = (itemId) => {
    if (itemId === "he") return "minifiedLFInsights"
    if (itemId === "ai") return "minifiedMFInsights"
    return "minifiedUFInsights"
}
export const getTrackKeyPersona = (itemId) => {
    if (itemId === "he") return "minifiedLFPersona"
    if (itemId === "ai") return "minifiedMFPersona"
    return "minifiedUFPersona"
}
export const getTrackKeyCreatePackage = (itemId) => {
    if (itemId === "he") return "minifiedLFCreatePackage"
    if (itemId === "ai") return "minifiedMFCreatePackage"
    return "minifiedUFCreatePackage"
}

export const getInterestLevel = (itemId) => {
    const heText = getWhiteLabelDictionary(highlyEngagedObj.key, highlyEngagedObj.title)
    const aiText = getWhiteLabelDictionary(activelyInterestedObj.key, activelyInterestedObj.title)
    if (itemId === "he") return heText
    if (itemId === "ai") return aiText
    return `${heText}, ${aiText}`
}

export const getGenderDistribution = (data) => {
    try {
        const { female, male } = data?.genderAgeObj?.gender_distribution || {}
        if (female === male) return "Equal"
        if (female > male) return "Female"
        return "Male"
    } catch (error) {
        return ""
    }
}

export const getHighestAge = (data) => {
    try {
        const { age_group_distribution } = data?.genderAgeObj || {}
        const highestScore = Math.max(...Object.values(age_group_distribution || {}))
        return Object.keys(age_group_distribution || {}).find((key) => age_group_distribution[key] === highestScore)
    } catch (error) {
        return ""
    }
}
export const hightLightHeader = (itemId) => {
    const itemSelectorHE = ".collapse-header-Highly.Engaged"
    const itemSelectorAI = ".collapse-header-Actively.Interested"

    const hightLightItem = (itemSelector) => {
        const item = window.document.querySelector(itemSelector);
        if (item) {
            item.style.backgroundColor = "yellow"
            setTimeout(() => {
                item.style.backgroundColor = ""
            }, 1000)
        }
    }
    if (itemId === "he" || itemId === "all") {
        hightLightItem(itemSelectorHE)
    }
    if (itemId === "ai" || itemId === "all") {
        hightLightItem(itemSelectorAI)
    }
}
export const scrollTo = (itemId, value, isAll) => {
    const scrollElem = (elem) => {
        if (elem) {
            elem.scrollIntoView({ behavior: "smooth", inline: "end", block: "nearest" });
        }
    }
    const scrollPerIntertLevel = (catName, interest) => {
        const itemSelector = `.collapse-${CSS.escape(catName.replace(/ /g, "_"))}-${interest.replace(/ /g, "_")}`
        scrollElem(window.document.querySelector(itemSelector))
        setTimeout(() => {
            scrollElem(window.document.querySelector(`${itemSelector} .ant-collapse-content-box`))
        }, 1000)
    }
    try {
        if (itemId === "all") {
            if (isAll) {
                scrollElem(window.document.querySelector(".minified-result-item.collapse"))
            } else {
                getInterestLevel(itemId).split(", ").forEach((inter) => {
                    scrollPerIntertLevel(value, inter)
                })
            }
        } else {
            scrollPerIntertLevel(value, getInterestLevel(itemId))
        }
    } catch (error) {

    }
}